import { grpc } from '@improbable-eng/grpc-web'
import { NodeHttpTransport } from '@improbable-eng/grpc-web-node-http-transport'
import {
  AddReportRequest,
  GetReasonsRequest,
  ViolationReport
} from '~/stub/apigateway/report/violation_pb'
import { ViolationService } from '~/stub/apigateway/report/violation_pb_service'
import { commonMetaData } from '~/store/_helpers/common-helper'

// initial state
export const state = () => ({
  reasonsList: []
})

// getters
export const getters = {}

// actions
export const actions = {
  async fetchReasons({ commit, rootState }, params = {}) {
    const requestReply = await new Promise((resolve, reject) => {
      const request = new GetReasonsRequest()
      const metadata = commonMetaData(rootState)
      grpc.invoke(ViolationService.GetReasons, {
        request,
        metadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          resolve(message.toObject())
        },
        onEnd: (grpcCode, message, trailers) => {
          if (grpcCode !== grpc.Code.OK) {
            reject({ grpcCode, message })
          }
        }
      })
    })
    commit('RECEIVE_REASONS', requestReply)
  },
  async addReportRequest({ commit, rootState }, param = {}) {
    const addReportReply = await new Promise((resolve, reject) => {
      const request = new AddReportRequest()
      const metadata = commonMetaData(rootState)

      const violationReportList = param.violationReportList.map(report => {
        const violationReport = new ViolationReport()
        violationReport.setViolationReasonId(report.violationReasonId)
        violationReport.setComment(report.comment)
        return violationReport
      })

      request.setViolationReportsList(violationReportList)
      request.setServiceId(param.serviceId)
      request.setRequestId(param.requestId)
      grpc.invoke(ViolationService.AddReport, {
        request,
        metadata,
        host: process.env.config.grpcWebUrl,
        transport: NodeHttpTransport(),
        onMessage: message => {
          resolve(message.toObject())
        },
        onEnd: (grpcCode, message, trailers) => {
          if (grpcCode !== grpc.Code.OK) {
            reject({ grpcCode, message })
          }
        }
      })
    })
  }
}

// mutations
export const mutations = {
  RECEIVE_REASONS(state, data) {
    state.reasonsList = data.reasonsList
  }
}
